<template>
  <div class="line-miniapp-login-page">
    <div class="login-logo">
      <img :src="imgSrc.Logo" alt="logo">
    </div>

    <div class="miniapp-info">
      <img :src="imgSrc.miniappLogo" alt="Mini App Logo" class="miniapp-icon">
      <p class="miniapp-text">LINE MINI App</p>
    </div>

    <p class="text-lg font-medium text-slate-700">登入中
      <span class="inline-flex w-6">
        <span class="animate-[bounce_1.5s_infinite_0ms]">.</span>
        <span class="animate-[bounce_1.5s_infinite_200ms]">.</span>
        <span class="animate-[bounce_1.5s_infinite_400ms]">.</span>
      </span>
    </p>    

  </div>
</template>

<script>
export default {
  name: 'LineMiniappLogin',
  data() {
    return {
      miniappId: '2009413583-9PYxvOid',
      imgSrc: {
        Logo: require('@/assets/login/logoWithTitle.png'),
        miniappLogo: require('@/assets/login/line_miniapp.png'),
      }
    };
  },
  props: {
  },
  components: {
    
  },
  computed: {
    
	},
  watch: {
  },
  mounted() {
    // 引入 LIFF SDK
    const liffScript = document.createElement('script');
    liffScript.setAttribute('src', 'https://static.line-scdn.net/liff/edge/2/sdk.js');
    document.head.appendChild(liffScript);

    setTimeout(() => {
      this.liffProcess();
    }, 2000);
	},
  methods: {
    async liffProcess() {
      await window.liff.init({ liffId: this.miniappId });
      if (!window.liff.isLoggedIn()) {
        window.liff.login(); // 導向 LINE 授權頁
      } else {
        const idToken = window.liff.getIDToken();
        // console.log(idToken);
        // 1. 打你的 API 進行登入轉換
        const response = await fetch('/closet/api/lineLoginByMiniAppToken', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ liff_token: idToken })
        });
        const resJson = await response.json();
        // console.log(resJson);
        if (resJson.status === 'ok') {
          // 2. 登入成功，儲存token並導轉
          console.log(resJson);
          await this.$store.dispatch('login', resJson.data.token);
          await this.$router.push({name: 'Home'});
        } else {
          alert(resJson.data.reason);
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
  .line-miniapp-login-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #f8fafc;

    .miniapp-info {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.5rem;

      .miniapp-icon {
        width: 2rem;
        object-fit: contain;
        margin-right: .5rem;
      }

      .miniapp-text {
        margin-bottom: 0;
        font-size: 1.25rem;
      }
    }

    .login-logo {
      margin-bottom: 1.5rem;
      img {
        width: 140px;
        height: auto;
      }
    }

    .text-lg {
      font-size: 1.125rem;
      line-height: 1.75rem;
    }

    .font-medium {
      font-weight: 500;
    }

    .text-slate-700 {
      color: #334155;
    }

    .inline-flex {
      display: inline-flex;
    }

    .w-6 {
      width: 1.5rem;
    }

    @keyframes bounce {
      0%, 100% {
        transform: translateY(-25%);
        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
      }
      50% {
        transform: translateY(0);
        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
      }
    }

    .animate-\[bounce_1\.5s_infinite_0ms\] {
      animation: bounce 1.5s infinite 0ms;
    }

    .animate-\[bounce_1\.5s_infinite_200ms\] {
      animation: bounce 1.5s infinite 200ms;
    }

    .animate-\[bounce_1\.5s_infinite_400ms\] {
      animation: bounce 1.5s infinite 400ms;
    }
  }
</style>